"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimatedRentalValue$ = exports.EstimatedRentalValue$outboundSchema = exports.EstimatedRentalValue$inboundSchema = void 0;
exports.estimatedRentalValueToJSON = estimatedRentalValueToJSON;
exports.estimatedRentalValueFromJSON = estimatedRentalValueFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.EstimatedRentalValue$inboundSchema = z.object({
    estimated_annual_rental_yield: z.nullable(z.number()),
    estimated_monthly_rental_value: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "estimated_annual_rental_yield": "estimatedAnnualRentalYield",
        "estimated_monthly_rental_value": "estimatedMonthlyRentalValue",
    });
});
/** @internal */
exports.EstimatedRentalValue$outboundSchema = z.object({
    estimatedAnnualRentalYield: z.nullable(z.number()),
    estimatedMonthlyRentalValue: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        estimatedAnnualRentalYield: "estimated_annual_rental_yield",
        estimatedMonthlyRentalValue: "estimated_monthly_rental_value",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var EstimatedRentalValue$;
(function (EstimatedRentalValue$) {
    /** @deprecated use `EstimatedRentalValue$inboundSchema` instead. */
    EstimatedRentalValue$.inboundSchema = exports.EstimatedRentalValue$inboundSchema;
    /** @deprecated use `EstimatedRentalValue$outboundSchema` instead. */
    EstimatedRentalValue$.outboundSchema = exports.EstimatedRentalValue$outboundSchema;
})(EstimatedRentalValue$ || (exports.EstimatedRentalValue$ = EstimatedRentalValue$ = {}));
function estimatedRentalValueToJSON(estimatedRentalValue) {
    return JSON.stringify(exports.EstimatedRentalValue$outboundSchema.parse(estimatedRentalValue));
}
function estimatedRentalValueFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.EstimatedRentalValue$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'EstimatedRentalValue' from JSON`);
}
//# sourceMappingURL=estimatedrentalvalue.js.map